import React from 'react'
import * as UI from 'ui'
import { CardWithHeader } from 'ui'
import { useEnvValue } from '@morningtrain/react-helpers'
import { Translation } from '@morningtrain/react-translations'
import * as Icons from 'ui/icons'
import { ModelWithForm, ValueToCollection } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import { Table } from 'ui/table'
import * as Columns from 'support/columns'
import FieldLabel from 'support/displays/FieldLabel'
import FieldActivity from 'support/displays/FieldActivity'
import FieldStatus from 'support/displays/FieldStatus'

export default function ChecklistInstance () {

  const [focusedList, setFocusedChecklist] = useEnvValue('checklist.focused_list', null)

  const unfocus = () => {
    setFocusedChecklist(null)
  }

  return (
    <ModelWithForm resourceName='checklists.checklists' id={focusedList}>
      <CardWithHeader header={<Displays.Text name='name'/>}>

        <a className={'text-sm whitespace-no-wrap text-gray-400 hover:text-primary-500 inactive'} onClick={unfocus}>
          <UI.Button className='mb-4'>
            <Icons.ArrowLeft className='mr-2'/>
            <span><Translation name={'to_overview'}/></span>
          </UI.Button>
        </a>


        <ValueToCollection name='fields'>
          <Table>
            <Columns.Column label={<Translation name='task'/>} display={<FieldLabel/>}/>
            <Columns.Column label={<Translation name='activity'/>} display={<FieldActivity/>}/>
            <Columns.Column label={<Translation name='status'/>} display={<FieldStatus/>}/>
          </Table>
        </ValueToCollection>
      </CardWithHeader>
    </ModelWithForm>
  )
}
